import PropTypes from "prop-types";

const CONNECTOR_COLORS = {
  completed: "tw-bg-theme-brand",
  in_progress: "tw-bg-theme-brand-lighter",
  incomplete: "tw-bg-neutral-gray-10",
};

const TITLE_STYLES = {
  completed: "tw-text-12px tw-leading-[16px] tw-font-normal tw-text-gray-75",
  in_progress: "tw-text-12px tw-leading-[16px] tw-font-semibold tw-text-theme-brand",
  incomplete: "tw-text-12px tw-leading-[16px] tw-font-normal tw-text-neutral-gray-30",
};

const Dot = ({ status }) => {
  if (status === "in_progress") {
    return (
      <div className="tw-flex tw-justify-center tw-items-center tw-px-[8px] tw-pl-[2px] tw-w-[18px] tw-h-[8px]">
        <div className="tw-w-[8px] tw-h-[8px] tw-rounded-full tw-bg-theme-brand-lighter tw-border-2 tw-border-solid tw-border-tinted-gray-50 tw-shadow-[0_0_0_2px_var(--brand)]" />
      </div>
    );
  }

  if (status === "completed") {
    return (
      <div className="tw-flex tw-justify-center tw-items-center tw-px-[8px] tw-pl-[2px] tw-w-[18px] tw-h-[8px]">
        <div className="tw-w-[8px] tw-h-[8px] tw-rounded-full tw-bg-theme-brand" />
      </div>
    );
  }

  return (
    <div className="tw-flex tw-justify-center tw-items-center tw-px-[8px] tw-pl-[3px] tw-w-[17px] tw-h-[6px]">
      <div className="tw-w-[6px] tw-h-[6px] tw-rounded-full tw-bg-neutral-gray-10" />
    </div>
  );
};

Dot.propTypes = { status: PropTypes.string.isRequired };

const Connector = ({ status, isActive }) => {
  const connectorColor = CONNECTOR_COLORS[status] || CONNECTOR_COLORS.incomplete;
  return (
    <div
      className={`tw-flex tw-justify-center tw-items-center tw-w-[18px] tw-flex-1 tw-self-stretch ${isActive ? "tw-pt-[5px]" : "tw-pt-[2px]"} tw-px-[8px] tw-pl-[2px]`}
    >
      <div className={`tw-w-[2px] tw-self-stretch tw-rounded-[1px] ${connectorColor}`} />
    </div>
  );
};

Connector.propTypes = {
  status: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
};

const MilestoneList = ({ milestones = [] }) => (
  <div className="tw-pt-[12px]">
    {milestones.map((m, i) => {
      const isLast = i === milestones.length - 1;
      const titleStyle = TITLE_STYLES[m.status] || TITLE_STYLES.incomplete;
      const isActive = m.status === "in_progress";

      return (
        <div
          key={m.key}
          className={`tw-flex tw-items-start ${isActive ? "tw-pt-[3px]" : ""} ${isLast ? "" : "-tw-my-[2px]"}`}
        >
          <div className="tw-flex tw-flex-col tw-items-start tw-pt-[5px] tw-w-[18px] tw-shrink-0 tw-self-stretch">
            <Dot status={m.status} />
            {!isLast && <Connector status={m.status} isActive={isActive} />}
          </div>
          <div
            className={`tw-flex tw-flex-col tw-justify-center ${isActive ? "tw-pb-[14px] tw-flex-1" : "tw-pb-[10px] tw-flex-none"}`}
          >
            <span className={titleStyle}>{m.title}</span>
            {isActive && m.description && (
              <p className="tw-text-12px tw-leading-[16px] tw-font-normal tw-text-gray-75 tw-mt-0 tw-mb-0 tw-self-stretch">
                {m.description}
              </p>
            )}
          </div>
        </div>
      );
    })}
  </div>
);

MilestoneList.propTypes = {
  milestones: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      status: PropTypes.string.isRequired,
    }),
  ),
};

export default MilestoneList;
